export default __webpack_public_path__ + "static/media/lds-logo_vi.8b5c170e5cc02ce5.svg";